export default "__VITE_ASSET__ClKOdBu$__"